
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/openai-api-ui",
      function () {
        return require("private-next-pages/openai-api-ui.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/openai-api-ui"])
      });
    }
  